import { combineReducers } from "redux";
import FloormapReducer from "./FloormapReducer";
import LogInReducer from "./LogInReducer";
import SnackbarReducer from "./snackbarSlice";
import ProgressReducer from "./ProgressReducer";
import CentralMonitoringScreenReducer from "./CentralMonitoringScreenReducer";
import BuildingManagementReducer from "./BuildingManagementReducer";
import FloorManagementReducer from "./FloorManagementReducer";
import CustomerManagementReducer from "./CustomerManagementReducer";
import AlertSettingsReducer from "./AlertSettingsReducer";
import RememberDeviceReducer from "./RememberDeviceReducer";
import HealthStatusReducer from "./HealthStatusReducer";
import ResetPasswordReducer from "./ResetPasswordReducer";
import EmailDialogReducer from "./EmailDialogReducer";
import BackupCodesReducer from "./BackupCodesReducer";
import BackupLoginReducer from "./BackupLoginReducer";
import UserReducer from './UserReducer';
import mqttReducer from "./mqttReducers";
import SigninPageReducer from "./SigninPageReducer";
import PreferenceReducer from './PreferenceReducer'
import UpdatePasswordReducer from './UpdatePasswordReducer';
import ProfileReducer from './ProfileReducer'
import AddEditUserReducer from './AddEditUserReducer';
import AddEditDeviceReducer from './AddEditDeviceReducer';
import DeviceComponentReducer from './DeviceComponentReducer';
import HeaderReducer from './HeaderReducer'
import zoomReducer from "./ZoomSlice";
import Reducer911 from "./911Reducer";
import DeviceTypeReducer from './DeviceTypeReducer';
const rootReducer = combineReducers({
  snackbar: SnackbarReducer,
  floormap: FloormapReducer,
  login: LogInReducer,
  progress: ProgressReducer,
  CentralMonitoringScreenReducer,
  buildingData: BuildingManagementReducer,
  FloorManagementReducer: FloorManagementReducer,
  alertSettings: AlertSettingsReducer,
  rememberDevice: RememberDeviceReducer,
  customerData: CustomerManagementReducer,
  HealthStatusReducer,
  usersState: AddEditUserReducer,
  userList: UserReducer,
  resetPassword: ResetPasswordReducer,
  setPasswordData: UpdatePasswordReducer,
  emailDialog: EmailDialogReducer,
  addEditDevice: AddEditDeviceReducer,
  deviceComponent: DeviceComponentReducer,
  backupCodes: BackupCodesReducer,
  backupLogin: BackupLoginReducer,
  profile: ProfileReducer,
  mqtt: mqttReducer,
  signinPage: SigninPageReducer,
  HeaderReducer: HeaderReducer,
  notificationData: PreferenceReducer,
  zoom: zoomReducer,
  DeviceTypeReducer:DeviceTypeReducer,
  nine11: Reducer911,
});

export default rootReducer;
